import type { IDesktopControlsProps } from "../../types";
import { Close } from "@mui/icons-material";
import { Button, IconButton } from "@mui/material";

export default function DesktopControls(props: IDesktopControlsProps) {
  const { buttonText, handleCapture, handleClose, styles } = props;

  return (
    <>
      <IconButton sx={styles.desktopExit} onClick={handleClose}>
        <Close />
      </IconButton>

      <Button color="primary" variant="contained" sx={styles.desktopCapture} onClick={handleCapture}>
        {buttonText}
      </Button>
    </>
  );
}
